import { render, staticRenderFns } from "./NativeBar.vue?vue&type=template&id=7452b402&scoped=true&"
import script from "./NativeBar.vue?vue&type=script&lang=js&"
export * from "./NativeBar.vue?vue&type=script&lang=js&"
import style0 from "./NativeBar.vue?vue&type=style&index=0&id=7452b402&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7452b402",
  null
  
)

export default component.exports